// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"jD-z","smallCardRow":"kD-z","largeCardRow":"lD-z","productSearchRow":"mD-z","curatedRow":"nD-z"};